/**
 * Product Domain Define Transition Screen (Step 10)
 * Wraps DefineConditionsAndPlanks. User must select 2–4 friction questions in Friction Priorities first.
 */
import React from 'react';
import { DefineConditionsAndPlanks } from '../BridgeSession/DefineConditionsAndPlanks';

interface ProductDefineConditionsScreenProps {
  sessionId: string;
  onNext: () => void;
  onBack: () => void;
}

export const ProductDefineConditionsScreen: React.FC<ProductDefineConditionsScreenProps> = ({
  onNext,
  onBack,
}) => {
  return (
    <DefineConditionsAndPlanks
      onComplete={onNext}
      onBack={onBack}
      backLabel="Back to Friction Priorities"
    />
  );
};
